<template>
	<div class="support-page mid-container">
		<h1>{{ $t("support.title") }}</h1>
		<i18n-t keypath="support.body" tag="p" class="subtitle">
			<template #email>
				<a href="mailto:info@valormovies.com">info@valormovies.com</a>
			</template>
		</i18n-t>
	</div>
</template>

<script setup lang="ts">
	// Support page
</script>

<style lang="scss" scoped>
	.support-page {
		padding: 100px 12px;
		@include br.respond-to(br.$mobile-xlarge) {
			padding: 80px 12px;
		}
		text-align: center;

		.subtitle {
			font-size: 20px;
			line-height: 30px;
			margin-bottom: 0;

			a {
				text-decoration: underline !important;
			}
		}

		h1 {
			font-size: 40px;
			font-weight: 800;
			line-height: 54px;
			padding-bottom: 15px;
			margin: 0;

			@include br.respond-to(br.$tablet-large) {
				font-size: 48px;
				line-height: 52px;
			}
			@include br.respond-to(br.$mobile-xlarge) {
				font-size: 24px;
				line-height: 32px;
			}
		}
	}
</style>
